import React from "react";
import styled from "styled-components";
import Modal from "react-modal";

const ModalContent = styled.div`
  padding: 24px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
`;

const Message = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const InputField = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 24px;

  &:focus {
    outline: none;
    border-color: #3398b8;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:focus {
    outline: none;
  }
`;

const CancelButton = styled(Button)`
  background-color: #f5f5f5;
  color: #333;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const ConfirmButton = styled(Button)`
  background-color: ${(props) => (props.$danger ? "#d32f2f" : "#3398b8")};
  color: white;

  &:hover {
    background-color: ${(props) => (props.$danger ? "#b71c1c" : "#287a94")};
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: 0,
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    minWidth: "400px",
    maxWidth: "500px",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  },
};

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  danger = false,
  requireConfirmation = false,
  confirmationWord = "DELETE",
}) => {
  const [inputValue, setInputValue] = React.useState("");

  const handleConfirm = () => {
    if (requireConfirmation && inputValue !== confirmationWord) {
      return;
    }
    onConfirm();
    setInputValue("");
    onClose();
  };

  const handleCancel = () => {
    setInputValue("");
    onClose();
  };

  const isConfirmDisabled =
    requireConfirmation && inputValue !== confirmationWord;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCancel}
      style={customStyles}
      contentLabel={title}
    >
      <ModalContent>
        <Title>{title}</Title>
        <Message>{message}</Message>
        {requireConfirmation && (
          <InputField
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={`Type "${confirmationWord}" to confirm`}
            autoFocus
          />
        )}
        <ButtonContainer>
          <CancelButton onClick={handleCancel}>{cancelText}</CancelButton>
          <ConfirmButton
            onClick={handleConfirm}
            $danger={danger}
            disabled={isConfirmDisabled}
          >
            {confirmText}
          </ConfirmButton>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmDialog;
